/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { token } from '@atlaskit/tokens';

export const PanelHeader = styled.div({
  display: 'flex',
  alignItems: 'center',
});

export const PanelHeaderWrapper = styled.div({
  display: 'flex',
});

export const BranchSyncInfoWrapper = styled.div({
  marginLeft: token('space.100'),
});

export const CommitListHeading = styled.h2({
  font: token('font.heading.xsmall'),
  marginTop: 0,
});

export const CommitList = styled.section({
  margin: '0 auto',
});
